import { findNode, findNodeParent } from "@/lib/tree/tree";
import { breakdanceStoreActions } from "@/store/actions/store-actions";
import { SingularityUIState } from "@/store/modules/singularity";
import { documentStore, singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";

import { getFutureLayerElementBehavior } from "./element-behavior";
import { registerFutureLayerElementBehaviors } from "./register-element-behavior";
import { isFutureLayerMode } from "@/futurelayer/ui/ui";

export function registerFutureLayerElementBehaviorActions() {
  registerFutureLayerElementBehaviors();

  breakdanceStoreActions.register.onActivatedElement(({ elementId }) => {

    if (!isFutureLayerMode()) {
      return;
    }

    const element = findNode(documentStore.document.tree, elementId);
    if (!element) return;
    const behavior = getFutureLayerElementBehavior(element?.data.type);
    openInitialPanel(behavior.initialPanel);
    behavior.setPanelState(element);
  });
}

function openInitialPanel(
  panel: SingularityUIState["singularityLeftPanel"] | "none"
) {
  if (panel !== "none") {
    singularityStore.setSingularityLeftPanel(panel);
  }
}
